// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1vzPM","title":"Header_title__2fuhI","left":"Header_left__2Jk9Y","clinicName":"Header_clinicName__2OVrV"};